// 8.3.7 — learner level control (merged into the locale as `lvl`).
const lvl = {
  "changeLevel": "Niveau ändern",
  "title": "Ändere dein Niveau in {lang}",
  "help": "Wähl das Niveau, das sich für dich richtig anfühlt. Du kannst es jederzeit ändern.",
  "safe": "Deine gespeicherten Wörter, Wiederholungen und Fortschritte bleiben erhalten.",
  "save": "Niveau speichern",
  "cancel": "Abbrechen",
  "saving": "Wird gespeichert…",
  "changed": "Niveau auf {level} geändert. Deine weiteren Übungen passen sich deinem neuen Niveau an.",
  "failed": "Dein Niveau konnte nicht geändert werden. Versuch es noch einmal.",
  "current": "Aktuell",
  "profilesHelp": "Dein Sprachprofil und sein GER-Niveau. Eine Änderung wirkt sich nur auf künftige Übungen aus.",
  "levels": {
    "A1": {
      "name": "Anfänger",
      "desc": "Grundwortschatz und einfache Alltagssätze."
    },
    "A2": {
      "name": "Grundlegende Kenntnisse",
      "desc": "Vertraute Situationen und kurze Gespräche."
    },
    "B1": {
      "name": "Mittelstufe",
      "desc": "Du meisterst Alltagsgespräche immer selbstständiger."
    },
    "B2": {
      "name": "Gute Mittelstufe",
      "desc": "Du sprichst natürlich über viele Themen und verstehst auch komplexere Sprache."
    },
    "C1": {
      "name": "Fortgeschritten",
      "desc": "Du drückst dich flüssig aus und erfasst feine Nuancen."
    },
    "C2": {
      "name": "Annähernd muttersprachlich",
      "desc": "Du verstehst und formulierst fast alles präzise."
    }
  }
};
export default lvl;
